export const CASES = {
    UPDATE_JOB_METRICS: 'UPDATE_JOB_METRICS',
    UPDATE_JOB_METRICS_FORM: 'UPDATE_JOB_METRICS_FORM',
    CLEAR_JOB_METRICS: 'CLEAR_JOB_METRICS',
};
